import apiWorker from '../apiWorker'

const companies =  {
    create        : (data) =>  apiWorker('post', `/v1/admin/channel_partners`, data, true),
    search        : (data) =>  apiWorker('post', `/v1/admin/channel_partners/search`, data, true),
    update        : (_id, data) =>  apiWorker('patch', `/v1/admin/channel_partners/${_id}`, data, true),
    findById      : (_id, data) =>  apiWorker('get', `/v1/admin/channel_partners/${_id}`, null, true),
}

export default companies;